import { t } from 'localization/utils/t';

const TP = 'shared.utils.localizeCondition';

export const localizeCondition = (text: string) => {
  if (!text || typeof text !== 'string') {
    return text;
  }
  switch (text?.toLowerCase()) {
    case 'badly damaged':
    case 'badly_damaged':
      return t(`${TP}.badlyDamaged`, 'Badly Damaged');
    case 'goat clean':
    case 'goat_clean':
      return t(`${TP}.goatClean`, 'Goat Clean');
    case 'good condition':
    case 'good_condition':
      return t(`${TP}.goodCondition`, 'Good Condition');
    case 'missing lid':
    case 'missing_lid':
      return t(`${TP}.missingLid`, 'Missing Lid');
    case 'new':
      return t(`${TP}.new`, 'New');
    case 'new with defects':
    case 'new_with_defects':
      return t(`${TP}.newWithDefects`, 'New With Defects');
    case 'no original box':
    case 'no_original_box':
      return t(`${TP}.noOriginalBox`, 'No Original Box');
    case 'used':
      return t(`${TP}.used`, 'Used');
    default:
      return text;
  }
};
